import { connect } from 'react-redux'
import config from 'config'

//import{} from 'state/actions'

function mapStateToProps(state) {
  return {
  	error: state.error,
  	saveSuccess: state.saveSuccess,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
  }
}

export default function (component) {
  return connect(mapStateToProps, mapDispatchToProps)(component)
}


// WEBPACK FOOTER //
// ./components/form/app-container.js